/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignmentConflictResponseDto
 */
export interface AssignmentConflictResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    assetId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    serialNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    zoneName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    conflictingPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof AssignmentConflictResponseDto
     */
    conflictingPlanName: string;
    /**
     * 
     * @type {Date}
     * @memberof AssignmentConflictResponseDto
     */
    since: Date;
}

/**
 * Check if a given object implements the AssignmentConflictResponseDto interface.
 */
export function instanceOfAssignmentConflictResponseDto(value: object): value is AssignmentConflictResponseDto {
    if (!('assetId' in value) || value['assetId'] === undefined) return false;
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('siteName' in value) || value['siteName'] === undefined) return false;
    if (!('conflictingPlanId' in value) || value['conflictingPlanId'] === undefined) return false;
    if (!('conflictingPlanName' in value) || value['conflictingPlanName'] === undefined) return false;
    if (!('since' in value) || value['since'] === undefined) return false;
    return true;
}

export function AssignmentConflictResponseDtoFromJSON(json: any): AssignmentConflictResponseDto {
    return AssignmentConflictResponseDtoFromJSONTyped(json, false);
}

export function AssignmentConflictResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignmentConflictResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetId': json['assetId'],
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'],
        'zoneName': json['zoneName'] == null ? undefined : json['zoneName'],
        'siteName': json['siteName'],
        'conflictingPlanId': json['conflictingPlanId'],
        'conflictingPlanName': json['conflictingPlanName'],
        'since': (new Date(json['since'])),
    };
}

export function AssignmentConflictResponseDtoToJSON(json: any): AssignmentConflictResponseDto {
    return AssignmentConflictResponseDtoToJSONTyped(json, false);
}

export function AssignmentConflictResponseDtoToJSONTyped(value?: AssignmentConflictResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['assetId'],
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'zoneName': value['zoneName'],
        'siteName': value['siteName'],
        'conflictingPlanId': value['conflictingPlanId'],
        'conflictingPlanName': value['conflictingPlanName'],
        'since': value['since'].toISOString(),
    };
}

